import React, { useState, useEffect} from "react";
import styled from "@emotion/styled";
import { useCountdown } from "./UseCountdown";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import withTranslator from "../Translator/withTranslation";
import withFosRouter from "../FosRouter/withFosRouting";
import _additionalfn from "../../_additionalfn";

import { compose } from "recompose";

const CountDownItem = styled.div `
    color: #fff;
    font-size:1.6em;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding:0.5em;
    position: relative;
    width: auto;
    height: auto;
    @media (max-width: 499px) {
        font-size:1.2em;
        margin:0px;
        padding: 0.5em;
        line-height: 1em;
    }
    @media (min-width: 500px) and (max-width: 1024px) {
        padding: 0.35em;
    }
`;
const CountDownItemLabel = styled.span `
    color: #fff;
    font-size: 0.4em;
    font-weight: 600;
    text-transform: uppercase;
    @media (max-width: 499px) {
        font-size: 0.5em;
        margin: 0px;
    }
`;

const CountDownWrapper = styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    z-index:1000;
    width:100%;
    border-radius:0px 0px 3px 3px;
    @media (max-width: 499px ) {
        font-size:0.6em;
    }
    @media (min-width: 499px) and (max-width: 1024px ) {
        font-size:0.7em;
    }
    @media (min-width: 1024px) and (max-width: 1440px ) {
        font-size:0.9em;
    }
`;
const DiscountAmount = styled.div `
    background: #0c7;
    padding: 0.41em;
    font-size: 1.6em;
    line-height: 1em;
    color: #fff;
    @media (max-width: 499px) {
        font-size:1.5em;
        margin:5px;
        padding: 0px;
        line-height: 0.9em;
    }

    @media (min-width: 500px) and (max-width: 1024px) {
        font-size: 1.8em;
    }
`;
const DiscountLabel = styled.div `
   color:#fff;
   text-transform: uppercase;
   background: #0c7;
   border-radius: 3px;
`;

const DiscountHeader = styled.div `
    color:#fff;
    padding:0 0.5em;
    font-size:1.2em;
    line-height: 1.2em;
    font-weight:600;
    @media (max-width: 499px) {
        font-size:0.9em;
        margin:5px;
        line-height: 1.5em;
        display:none;
    }
    @media (min-width: 500px ) and (max-width: 768px) {
        font-size:1.4em;
        margin:5px;
    }
    @media (min-width: 769px) and (max-width: 1024px) {
        font-size:1.5em;
        margin:5px;
    }
`;
const DiscountTimerContainer = styled.div `
    background:#f00;
    color:#fff;
    display: flex;
    margin: 0 1em;
    border-radius: 3px;
    padding: 0.05em 0;
    @media (max-width: 499px) {
        flex: 2;
        width: max-content!important;
        max-width: fit-content;
    }
`
const Button = styled.a `
    padding:0.6em!important;
    text-align:center;
    width: max-content;
    max-width: max-content;
    border-radius:3px;
    @media (max-width: 499px) {
        width: min-content;
        text-align:center!important;
        font-size: 0.8em!important;
    
    }
    @media (min-width: 499px) and (max-width: 767px) {
        width: min-content;
        padding:1.2em!important;
        text-align:center;
        font-size: 0.8em!important
    }
    @media (min-width:768px) and (max-width: 1023px) {
        font-size:1em!important;
        padding:0.6em!important;
        width: min-content;
        text-align:center;
    }
    @media (min-width: 1024px) and (max-width: 1440px ) {
        padding: 0.7em!important;
    }

`;
const ButtonContainer = styled.div `
    display:flex;
    font-size:1.8em;
    @media (max-width: 499px) {
        font-size:1.2em;
        margin: 5px 0px;
    }
    @media (min-width: 500px)  and (max-width: 768px) {
        font-size:1.2em;
        margin:5px;
    }
    @media (min-width: 768px) and (max-width: 1024px) {
        font-size:1.4em;
        margin:5px;
    }

`

 const DiscountTimerComponent = (props) => {
    const breakPoint = 150;
    const initScrollStyle = props.mobile ? {
        left: "0px",
        padding: "0.75em",
    } : {
        left: "50%",
        transform: "translate(-50%,0%)",
        maxWidth: "1410px"
    }
    const [isActive, setIsActive] = useState(props.active);
    const [discountAmount, setDiscountAmount] = useState(props.discount_amount);
    const [timeTillDate, setTimeTillDate] = useState(props.discountEndsAt ? props.discountEndsAt : null);
    const [scrollYStyle, setScrollYStyle] = useState( initScrollStyle );
    const [bookingRoute, setBookingRoute] = useState( props.bookingRoute );
    const timerRef = React.createRef();

    if (props.mobile) {
        useScrollPosition(
        ({ prevPos, currPos }) => {
            const triggered = currPos.y < -1*breakPoint;

            const shouldBeStyle = {
                position: triggered ? "fixed" : "relative",
                top: "0px",
                transform: triggered ? "scale(0.9)" : "scale(1)",

            }
            if (JSON.stringify(shouldBeStyle) === JSON.stringify(scrollYStyle)) return
            setScrollYStyle(shouldBeStyle)
        }, [scrollYStyle]
        )
    } else {
        useScrollPosition(
            ({ prevPos, currPos }) => {
                const triggered = currPos.y < -1*breakPoint;
                const shouldBeStyle = {
                    left: "50%",
                    transform: "translate(-50%,0%)",
                    maxWidth: "1410px",
                    position: triggered ? "fixed" : "relative",
                    top: triggered ? "0px" : "initial",
                }
                if (JSON.stringify(shouldBeStyle) === JSON.stringify(scrollYStyle)) return
                setScrollYStyle(shouldBeStyle)
            }, [scrollYStyle]
        )
    }

    const onUpdatePrices = (event) => {
        setDiscountAmount(event.detail.discount);
        setTimeTillDate((event.detail.discountEndsAt) ? event.detail.discountEndsAt : props.discountEndsAt);
        setIsActive(event.detail.active);
        onUpdateButton(event);

        var sideBarContainer = document.getElementById('sidebar-container');
        if (sideBarContainer !== null) {
            if (event.detail.active) {
                sideBarContainer.style.top = '105px';
            } else {
                sideBarContainer.style.top = '15px';
            }
        }
    };

    const onUpdateButton = (event) => { 
        var params = _additionalfn.tokenize(props.query);
        params.stayStart = event.detail.start;
        params.stayEnd = event.detail.end;
        var query = _additionalfn.stringify(params);
        // check for google analytics and set linkerparams for bookingdomain
        if (typeof ga === 'function' && typeof ga.getAll === 'function') {
            if (ga.getAll().count) {
                var linkerParam = ga.getAll()[0].get('linkerParam');
                var linkerParamValue = linkerParam.split('=')[1];
                setBookingRoute(props.r('booking_with_query', {'city': props.citySlug, 'name': props.nameSlug, 'query': query, '_locale': props.locale,  '_ga' : linkerParamValue }));
            } else {
                setBookingRoute(props.r('booking_with_query', {'city': props.citySlug, 'name': props.nameSlug, 'query': query, '_locale': props.locale }));
            }
        } else {
            setBookingRoute(props.r('booking_with_query', {'city': props.citySlug, 'name': props.nameSlug, 'query': query, '_locale': props.locale }));
        }
    }
    const countDown = useCountdown(timeTillDate, props.timeFormat);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.scrollY > breakPoint ) {
                if (props.mobile) {
                    setScrollYStyle({
                        left: "0px",
                        padding: "0.75em",
                        position: "fixed",
                        transform: "scale(0.9)" ,
                        top: "0px"
                    });
                } else {
                    setScrollYStyle({
                        left: "50%",
                        transform: "translate(-50%,0%)",
                        maxWidth: "1410px",
                        position: "fixed",
                        top: "0px"
                    });
                }
            }
        }

        document.addEventListener("Calendar_UPDATE_PRICES", onUpdatePrices);
        return () => {
            document.removeEventListener("Calendar_UPDATE_PRICES", onUpdatePrices);
        };
    }, []);

    return (
        (isActive && timeTillDate !== null ) && (
        <CountDownWrapper ref={timerRef} className="bg-blue3 px-1 px-sm-3 py-0 py-sm-2 top-0  flex items-center justify-sbetween  " style={{ ...scrollYStyle }}>
            <DiscountLabel >
                <DiscountAmount className="lineheight-1 mx-sm-3 items-center" id="discount-amount-ref" >{discountAmount}<div className="font-60 pt-sm-1 text-center">{props.t('discount')}</div></DiscountAmount>
            </DiscountLabel>
            
            <DiscountTimerContainer className="discount-timer px-sm-1 items-center">
                <DiscountHeader dangerouslySetInnerHTML={{ __html: props.t('villadiscount.limitedtimeoffer_expires').split('.').join('.<br />') + ':' }}></DiscountHeader>
                    <div className="py-sm-1 px-sm-1 text-center width-maxcontent">
                        {countDown.days !== '' && (
                            <CountDownItem>
                                {countDown.days}
                                <CountDownItemLabel>{props.t('days')}</CountDownItemLabel>
                            </CountDownItem>
                        )}
                        {countDown.hours !== '' && (
                            <CountDownItem>
                                {countDown.hours}
                                <CountDownItemLabel>{props.t('hours')}</CountDownItemLabel>
                            </CountDownItem>
                        )}
                        {countDown.minutes !== '' && (
                            <CountDownItem>
                                {countDown.minutes}
                                <CountDownItemLabel>{props.t('minutes')}</CountDownItemLabel>
                            </CountDownItem>
                        )}
                        {countDown.seconds !== '' && (
                            <CountDownItem>
                                {countDown.seconds}
                                <CountDownItemLabel>{props.t('seconds')}</CountDownItemLabel>
                            </CountDownItem>
                        )}
                    </div>
            </DiscountTimerContainer>
            <ButtonContainer><Button id="discount-book-button" className="btn btn-secondary uppercase width-mincontent" href={bookingRoute}>{props.t('booknow')}<span style={{marginLeft: "4px"}}>›</span></Button></ButtonContainer>
        </CountDownWrapper>
        )
    );
};

export const DiscountTimer = compose(
    withTranslator,
    withFosRouter,
)(DiscountTimerComponent);